import { configureStore, combineReducers, Tuple, Middleware, Action, createReducer, createAction } from '@reduxjs/toolkit'
//import itemReducer from '../Redux/Admin_Tasks/MDSSlice'
import { emailConfirmationAPI, registerFormAPI } from './Register/registerSlice'
import logger from 'redux-logger'
import { signinFormAPI } from './SignIn/signinSlice'
import wlmReducer from './WLM/wlmReducer'
import rolesReducer from '../Redux/Admin_Tasks/ManageRoleSlice'
import { contactFormAPI } from './contact/contactSlice'
import {AppDimensionApi} from './Admin_Tasks//DimensionSlice/ManageDimensionSLice'
import { adminApi } from '../Redux/Admin_Tasks/AdminProcedureSlice';
import {businessParameterApi} from './Admin_Tasks/BusinessParameterSlice'
import { dataMapperAPI } from './Admin_Tasks/DataMapperSlice'
import { Log4Net } from './Admin_Tasks/Log4NetSlice'
import { VuTarget } from './VisualUnitTarget/VisualUnitTargetSlice'
import MDSTool from './Admin_Tasks/MDSSlice'
import userReducer from './User/userSlice'
import userSlice, { currentUserAPI } from './User/userSlice'
import workspaceReducer from './Workspace/workspaceSlice'
import { workspaceFormAPI } from './Workspace/workspaceSlice'
import { workspaceApi } from './Workspace/workspaceActionsSlice'
import appsettingReducer from './App/appSlice'
import { appSettingsAPI } from './App/appSlice'
import { visualUnitApi } from './ReportActions/reportActionsSlice'
import { executeAPI, VUConfigAPI } from './VisualUnits/visualUnitAPISlice'
import { getVuParamsAPI } from './VisualUnits/visualUnitAPISlice'
import paginationReducer from './Pagination/paginationSlice'
import {openReportActionsReduecer, reportVUInfoReducer, editSaveInitialPayloadReducer,RunVUDataPayloadReducer} from './VisualUnits/visualUnitStateSlice'
import { vuObjInfoReducer, vuParamsInfoReducer} from './VisualUnits/visualUnitStateSlice'
import triggerReducer from './TriggerApi/triggerApiSlice'
import { drillThruActionsApi, drillThruFormAPI } from './DrillThru/DrillThruSlice'
// import { reportActionsSlice } from './ReportActions/reportActionsSlice'
import reportsActions from './ReportActions/reportActionsSlice'
import workspaceActionsReducer from './Workspace/workspaceActionReducers'
import { HomeWorkspaceApi } from './Home/HomeWorkspaceSlice'
import { Invite } from './Admin_Tasks/InviteSlice'
import lmsReducer from './LeaveManager/LmsIdSlice';
import { drillThruObjReducer, drillThruInitialPayloadReducer } from './DrillThru/DrillThruSlice'
import { LeaveManager } from './LeaveManager/LeaveMangerSlice'
import { ResetpasswordApi } from './ResetPassword/ResetPasswordSlice'
import {  objectViewerApi } from './OCV/OCVSlice'
import { UserNotifications } from './Notifications/NotificationSlice'
import runSqlQueriesReducer from '../Redux/Admin_Tasks/RunSqlQueriesSlice';
import { appWorkflowStates } from '../Types/appWorkflowStates'
import  forgotPasswordFormSlice, { forgotPasswordFormAPI }  from "../Redux/forgotPassword/forgotPasswordSlice";
import { userSettings } from "./UserSettings/userSettingsSlice";
import statCaseReducer, { StatCaseAPI } from './StatCase/StatCaseSlice';
import { ManageActivity } from './Admin_Tasks/ManageActivitySlice'
import { ManageUsersApi } from './Admin_Tasks/userAccountSlice'
//import userSettingsSlice from "./UserSettings/userSettingsSlice";
import { sendEmailConfirmationApi } from './EmailConfirmation/sendEmailConfirmationSlice'
import {setDrillThruColumnView} from '../Redux/VisualUnits/visualUnitAPISlice'

export const setAppWorkflowState = createAction<appWorkflowStates>("setAppWorkflowState")
export const setAppRedirectURL = createAction<string | null>("setAppRedirectURL")
export const setBusinessParameterList = createAction< [] | null>("setBusinessParameterList")

import { PayloadAction, ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { getAggricateListAPI } from './VisualUnits/vuParamSlice'
import { ssoSignInApi } from './SSOSignIn/SSOSignInSlice'

// Generic reducer function
function createGenericReducer <T>(actionCreator: ActionCreatorWithPayload<T>) {
    return createReducer<{ value: T | null }>({ value: null }, (builder) => {
      builder.addCase(actionCreator, (state, action: PayloadAction<T>) => {
        state.value = action.payload as typeof state.value; // Ensure type compatibility
      });
    });
  };

const rootReducer = combineReducers({
    [registerFormAPI.reducerPath]: registerFormAPI.reducer,
    [signinFormAPI.reducerPath]: signinFormAPI.reducer,
    [AppDimensionApi.reducerPath]: AppDimensionApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [contactFormAPI.reducerPath]: contactFormAPI.reducer,
    [businessParameterApi.reducerPath]:businessParameterApi.reducer,
    [drillThruFormAPI.reducerPath]: drillThruFormAPI.reducer,
    [dataMapperAPI.reducerPath]: dataMapperAPI.reducer,
    [executeAPI.reducerPath]: executeAPI.reducer,
    [getVuParamsAPI.reducerPath]: getVuParamsAPI.reducer,
    [VUConfigAPI.reducerPath]: VUConfigAPI.reducer,
    [Log4Net.reducerPath]: Log4Net.reducer,
    [VuTarget.reducerPath]:VuTarget.reducer,
    [currentUserAPI.reducerPath]: currentUserAPI.reducer,
    [workspaceFormAPI.reducerPath]: workspaceFormAPI.reducer,
    [workspaceApi.reducerPath]: workspaceApi.reducer,
    [appSettingsAPI.reducerPath] : appSettingsAPI.reducer,
    [visualUnitApi.reducerPath]: visualUnitApi.reducer,
    [HomeWorkspaceApi.reducerPath]: HomeWorkspaceApi.reducer,
    [LeaveManager.reducerPath]:LeaveManager.reducer,
    [ResetpasswordApi.reducerPath]:ResetpasswordApi.reducer,
   [objectViewerApi.reducerPath]: objectViewerApi.reducer,
   [drillThruActionsApi.reducerPath]: drillThruActionsApi.reducer,
   [userSettings.reducerPath]: userSettings.reducer,
   [getAggricateListAPI.reducerPath]: getAggricateListAPI.reducer,  
   [ManageActivity.reducerPath]: ManageActivity.reducer,
   [forgotPasswordFormAPI.reducerPath]: forgotPasswordFormAPI.reducer,
   [emailConfirmationAPI.reducerPath]: emailConfirmationAPI.reducer,
   [ManageUsersApi.reducerPath]: ManageUsersApi.reducer,
   [sendEmailConfirmationApi.reducerPath]: sendEmailConfirmationApi.reducer,
   [setDrillThruColumnView.reducerPath]: setDrillThruColumnView.reducer,
    [ssoSignInApi.reducerPath]: ssoSignInApi.reducer,

    [Invite.reducerPath]: Invite.reducer,
//    [OcvApi.reducerPath]: OcvApi.reducer,
    [UserNotifications.reducerPath]: UserNotifications.reducer,
    //items: itemReducer,
    user: userSlice,
    MDSTool: MDSTool,
    wlm: wlmReducer,
    rolesdata: rolesReducer,
    workspacedata: workspaceReducer,
    userdata : userReducer,
    forgotPasswordData: forgotPasswordFormSlice,
    runSqlQueries: runSqlQueriesReducer,
    appSettingDataPublic : appsettingReducer,
    pagination: paginationReducer,
    toggleReportAction: reportsActions,
    reportVUInfo: reportVUInfoReducer,
    openReportActions: openReportActionsReduecer,
    trigger: triggerReducer,
    drillThru_Obj: drillThruObjReducer,
    DrillThruInitialPayload: drillThruInitialPayloadReducer,
    WorkspaceActions: workspaceActionsReducer,
    EditSaveVUPayload: editSaveInitialPayloadReducer,
    VuObjectInfo: vuObjInfoReducer,
    VuParamsInfo: vuParamsInfoReducer,
    runVuDataPayload: RunVUDataPayloadReducer,
    lms: lmsReducer,
    
    [statCaseReducer.reducerPath]: statCaseReducer.reducer,
    [StatCaseAPI.reducerPath]: StatCaseAPI.reducer,

    //TODO: FP-10887 - Here are 2 reducers doing exactly same job
    appWorkflowState: createGenericReducer(setAppWorkflowState),
    appRedirectURL: createGenericReducer(setAppRedirectURL),
    businessParameterList: createGenericReducer(setBusinessParameterList)
})

export type RootState = ReturnType<typeof rootReducer>

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            // prepend and concat calls can be chained
            .concat(businessParameterApi.middleware)
            .concat(AppDimensionApi.middleware)
            .concat(adminApi.middleware)
            .concat(appSettingsAPI.middleware)
            .concat(ResetpasswordApi.middleware)
            .concat(signinFormAPI.middleware)
            .concat(workspaceApi.middleware)
            .concat(VUConfigAPI.middleware)
            .concat(visualUnitApi.middleware)
            .concat(VuTarget.middleware)
           .concat(executeAPI.middleware)
           .concat(getVuParamsAPI.middleware)
           .concat(HomeWorkspaceApi.middleware)
           .concat(currentUserAPI.middleware)
           .concat(ManageUsersApi.middleware)
           .concat(Invite.middleware) 
//           .concat(OcvApi.middleware)
           .concat(UserNotifications.middleware)
           .concat(workspaceFormAPI.middleware)
           .concat(drillThruFormAPI.middleware)
           .concat(objectViewerApi.middleware)
           .concat(Log4Net.middleware)
           .concat(drillThruActionsApi.middleware)
           .concat(userSettings.middleware)
           .concat(StatCaseAPI.middleware)
           .concat(getAggricateListAPI.middleware)
           .concat(dataMapperAPI.middleware)
           .concat(LeaveManager.middleware)
           .concat(ManageActivity.middleware)
           .concat(forgotPasswordFormAPI.middleware)
           .concat(emailConfirmationAPI.middleware)
           .concat(sendEmailConfirmationApi.middleware)
           .concat(registerFormAPI.middleware)
           .concat(setDrillThruColumnView.middleware)
           .concat(contactFormAPI.middleware)
           .concat(ssoSignInApi.middleware)
            //.concat(logger),
})
export type AppDispatch = typeof store.dispatch
export type AppState = ReturnType<typeof store.getState>
export default store

//TODO: FP-10887 - MAke a way to contain these functions in respective slices, as they were, so that state management is entirely contained within slice
export const getCurrentUserData = (state: RootState) => state.userdata.currentUserData;
export const getAppSettings = (state: RootState) => {
  const publicSettings = state.appSettingDataPublic.publicAppSetting || {};
  const protectedSettings = state.appSettingDataPublic.protectedAppSetting?.data || {};
  
  return {
      ...publicSettings,
      ...protectedSettings,
  };
};
export const getAppWorkflowState = (state: RootState) => state.appWorkflowState.value;
export const getAppRedirectURL = (state: RootState) => state.appRedirectURL.value;
export const getBusinessParameterList = (state: RootState) => state.businessParameterList.value;